import Layout from '@/components/layout';
import { Pages } from '@/lib/seoData';
import { NextSSRPage, withServerSideProps } from 'hoc/withServerSideProps';
import Link from 'next/link';

const AccessibilityPage: NextSSRPage = (props) => {
  return (
    <Layout {...props}>
      <div className="flex flex-col justify-center items-center pt-20 pb-10 px-4 lg:px-16">
        <h1 className="leading-[3.5rem] my-10 text-center">
          Website accessibility
        </h1>
        <p className='text-center lg:max-w-3xl'>Daily Polished takes website accessibility seriously and appreciates your feedback. Please provide us with as many specific details as to your accessibility issue as possible so we may research your concerns. You can contact us via our contact form <Link href='/contact' passHref><a className='underline'>here</a></Link> or via email at <a target="_blank" rel="noopener noreferrer" href="mailto:Care@DailyPolished.com">care@DailyPolished.com.</a></p>
      </div>
    </Layout>
  );
};

export const getServerSideProps = withServerSideProps(async function () {
  return { props: {} }
}, Pages.ACCESSIBILITY)

export default AccessibilityPage;
